import React, { useEffect, useState } from "react";
import { Offcanvas, Form } from "react-bootstrap";
import Common_Back_Btn from "../../../../../../../common/common_components/common_back_btn/Common_Back_Btn";
import { faEye } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Certification_Modal from "../../../../../../../common/common_modal/certification_modal/Certification_Modal";
import { useDispatch } from "react-redux";
import { GetSingle } from "../../../../../../../features/admin/quality_management/structural_requirement/scope_of_laboratoy/Slice";

function ScopeOfTheLaboratory_view_offcanvas({ show, handleClose, id }) {
  const [showModal, setShowModal] = useState(false);
  const [modalImage, setModalImage] = useState(null);
  const [details, setDetails] = useState(null);
  const dispatch = useDispatch();
  const GetData = async (id) => {
    const res = await dispatch(GetSingle(id));

    if (res?.payload?.success) {
      setDetails(res.payload.data);
    }
  };

  useEffect(() => {
    if (show === true && id) {
      GetData(id);
    }
  }, [show]);
  // console.log("detailsdetails of scope", details);
  return (
    <>
      <Offcanvas
        className="mobile_offcanvas Imperiality_view_offcanvas common_offcanvas"
        show={show}
        placement="end"
        onHide={handleClose}
      >
        <Offcanvas.Header>
          <Offcanvas.Title>
            <div className="back_div" onClick={handleClose}>
              <Common_Back_Btn />
            </div>
            View Scope Of The Laboratory
          </Offcanvas.Title>
        </Offcanvas.Header>

        <Offcanvas.Body>
          <div className="white_container customer_section">
            <div className="row">
              <div className="col-md-6">
                <Form.Group className="form_group">
                  <Form.Label>Discipline / Group</Form.Label>
                  <Form.Control value={details?.discipline} disabled />
                </Form.Group>
              </div>

              <div className="col-md-6">
                <Form.Group className="form_group">
                  <Form.Label>Material Or Products Tested</Form.Label>
                  <Form.Control
                    value={details?.Material_Tested?.name}
                    disabled
                  />
                </Form.Group>
              </div>

              <div className="col-md-6">
                <Form.Group className="form_group">
                  <Form.Label>
                    Component, Parameter Or Characteristic Tested / Specific
                    Test Performed / Tests Or Type Of Tests Performed
                  </Form.Label>
                  <Form.Control value={details?.Component?.name} disabled />
                </Form.Group>
              </div>

              <div className="col-md-6">
                <Form.Group className="form_group">
                  <Form.Label>
                    {" "}
                    Test Method Specification against which tests are performed
                    & / or the techniques / equipment used
                  </Form.Label>
                  <Form.Control value={details?.Test_Method?.name} disabled />
                </Form.Group>
              </div>
              {details?.Scope_Of_Laboratory_Documents?.length > 0 ? (
                details.Scope_Of_Laboratory_Documents.map((doc, index) => {
                  const fileUrl = doc.document_path
                    ? `${process.env.REACT_APP_IMG_URL}${doc.document_path}`
                    : null;

                  const fileType = doc.document_path?.toLowerCase();

                  return (
                    <div className="col-md-6" key={doc.id}>
                      <Form.Group className="form_group file_field">
                        <Form.Label>Attach File {index + 1}</Form.Label>

                        <div className="image_holder">
                          {/* IMAGE */}
                          {(fileType?.includes(".jpg") ||
                            fileType?.includes(".jpeg") ||
                            fileType?.includes(".png") ||
                            fileType?.includes(".webp")) && (
                            <img
                              className="img_preview"
                              src={fileUrl}
                              alt="Preview"
                              style={{ maxWidth: "150px" }}
                            />
                          )}

                          {/* PDF */}
                          {fileType?.includes(".pdf") && (
                            <iframe
                              src={fileUrl}
                              title="PDF Preview"
                              style={{ width: "200px", height: "100px" }}
                            />
                          )}

                          {/* WORD */}
                          {(fileType?.includes(".doc") ||
                            fileType?.includes(".docx")) && (
                            <div>
                              <p>Word Preview</p>
                              <iframe
                                src={`https://docs.google.com/gview?url=${fileUrl}&embedded=true`}
                                style={{ width: "150Px", height: "150px" }}
                                title="Word Preview"
                              />
                            </div>
                          )}

                          {/* EXCEL */}
                          {(fileType?.includes(".xls") ||
                            fileType?.includes(".xlsx")) && (
                            <div>
                              <p>Excel Preview</p>
                              <a
                                href={fileUrl}
                                target="_blank"
                                rel="noopener noreferrer"
                              >
                                Open Excel File
                              </a>
                            </div>
                          )}

                          {/* FALLBACK */}
                          {!fileType && (
                            <img
                              className="img_preview"
                              src="/assets/images/other/dummy-image.png"
                              alt="No preview"
                            />
                          )}
                        </div>

                        {/* 🔥 Actions */}
                        <div className="span_text_holder">
                          <div>
                            <span>Document {index + 1}</span>
                          </div>

                          <div>
                            <span
                              className="green_text"
                              onClick={() => {
                                setShowModal(true);
                                setModalImage(fileUrl);
                                handleClose();
                              }}
                            >
                              <FontAwesomeIcon icon={faEye} className="me-2" />
                              View
                            </span>
                          </div>
                        </div>
                      </Form.Group>
                    </div>
                  );
                })
              ) : (
                <div className="col-md-12 text-center">
                  <p>No documents available</p>
                </div>
              )}
              {/* {details?.Scope_Of_Laboratory_Documents?.length > 0 ? (
                details.Scope_Of_Laboratory_Documents.map((doc, index) => (
                  <div className="col-md-6" key={doc.id}>
                    <Form.Group className="form_group file_field">
                      <Form.Label>Attach File {index + 1}</Form.Label>

                      <div className="image_holder">
                        <img
                          className="img_preview"
                          src={
                            doc.document_path
                              ? `${process.env.REACT_APP_IMG_URL}${doc.document_path}`
                              : "/assets/images/other/dummy-image.png"
                          }
                        />
                      </div>

                      <div className="span_text_holder">
                        <div>
                          <span>Document {index + 1}</span>
                        </div>

                        <div>
                          <span
                            className="green_text"
                            onClick={() => {
                              setShowModal(true);
                              setModalImage(
                                doc.document_path
                                  ? `${process.env.REACT_APP_IMG_URL}${doc.document_path}`
                                  : null,
                              );
                              handleClose();
                            }}
                          >
                            <FontAwesomeIcon icon={faEye} className="me-2" />{" "}
                            View
                          </span>
                        </div>
                      </div>
                    </Form.Group>
                  </div>
                ))
              ) : (
                <div className="col-md-12 text-center">
                  <p>No documents available</p>
                </div>
              )} */}
            </div>
          </div>
        </Offcanvas.Body>
      </Offcanvas>
      <Certification_Modal
        show={showModal}
        onHide={() => setShowModal(false)}
        modalHeadingText={"View Scope Of The Laboratory"}
        imgSrc={modalImage}
        btnText={"Download"}
      />
    </>
  );
}

export default ScopeOfTheLaboratory_view_offcanvas;
